// Reusable section header for editorial feel
export default function SectionHeader({ overline, title, subtitle, align = "left", testid }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`max-w-3xl ${alignClass}`} data-testid={testid}>
      {overline && <p className="overline">{overline}</p>}
      <h2
        className="mt-4 text-4xl sm:text-5xl lg:text-6xl"
        style={{ fontFamily: "Playfair Display, serif" }}
      >
        {title}
      </h2>
      {subtitle && <p className="mt-6 text-soft text-base md:text-lg leading-relaxed">{subtitle}</p>}
    </div>
  );
}
